<!-- 侧边栏双排菜单一级 license by http://eleadmin.com -->
<template>
  <div class="ele-admin-sidebar-nav ele-scrollbar-hide">
    <slot name="top" />
    <el-scrollbar class="ele-admin-sidebar-nav-wrap ele-scrollbar-hide">
      <div class="ele-admin-sidebar-nav-menu ele-scrollbar-hide">
        <el-menu
          v-if="useDeep"
          :collapse="true"
          :class="themeClass"
          :unique-opened="true"
          :default-active="active"
          :collapse-transition="false"
        >
          <template v-for="item in data">
            <ele-pro-sidebar-item
              v-if="!item.meta.hide"
              :key="item.path"
              :item="item"
              :collapse="true"
              :pop-class="themeClass"
              :tooltip-disabled="!collapse"
              :first-pop-class="firstPopClass"
            />
          </template>
        </el-menu>
        <ele-pro-sidebar-menus
          v-else
          :data="data"
          :collapse="true"
          :unique-opened="true"
          :pop-class="themeClass"
          :default-active="active"
          :theme-class="themeClass"
          :collapse-transition="false"
          :tooltip-disabled="!collapse"
          :first-pop-class="firstPopClass"
        />
      </div>
    </el-scrollbar>
    <div
      v-if="showNavCollapse"
      class="ele-admin-sidebar-nav-tool-item"
      @click="toggleCollapse"
    >
      <i :class="collapse ? 'el-icon-_unfold' : 'el-icon-_fold'"></i>
    </div>
    <slot name="bottom" />
  </div>
</template>

<script>
  import EleProSidebarItem from './ele-pro-sidebar-item.vue';
  import EleProSidebarMenus from './ele-pro-sidebar-menus.vue';

  export default {
    name: 'EleProSidebarNav',
    components: { EleProSidebarItem, EleProSidebarMenus },
    emits: ['toggle-collapse'],
    props: {
      // 菜单数据
      data: Array,
      // 菜单选中
      active: String,
      // 是否使用递归渲染菜单item
      useDeep: Boolean,
      // 是否折叠
      collapse: Boolean,
      // 主题class, null | ele-menu-dark
      themeClass: String,
      // 是否显示折叠按钮
      showNavCollapse: Boolean
    },
    computed: {
      // 一级pop菜单主题
      firstPopClass() {
        const popClass = 'ele-admin-sidebar-nav-menu-pop';
        return this.themeClass ? this.themeClass + ' ' + popClass : popClass;
      }
    },
    methods: {
      /* 折叠展开侧栏 */
      toggleCollapse() {
        this.$emit('toggle-collapse');
      }
    }
  };
</script>
